import React from "react";
import KC_Heading2 from "../../../../../../designsystem/typography/KC-Heading/KC_Heading2";
import Separator from "../../../../../../components/Separator";
import KC_Text from "../../../../../../designsystem/typography/KC_Text/KC_Text";
import {
  KC_Text_Sizes,
  KC_Weights
} from "../../../../../../designsystem/ds_commons";
import UploadExistingPOSA from "./UploadExistingPOSA";
import { POSAOptionType } from "@tootsweet/model/entities/UploadedPOSA";
import UploadedPOSA from "@tootsweet/model/entities/UploadedPOSA";
import { tt } from "../../../../../../utils/i18n/i18n";

interface Props {
  existingPOSA: POSAOptionType[];
  uploadedPOSAList: UploadedPOSA[];
  onRefresh: () => Promise<void>;
}

export default function ExistingPOSASection(props: Props) {
  const hasItems =
    props.existingPOSA.length > 0 &&
    !props.existingPOSA.some((item) => item.format === "none");

  if (!hasItems) return null;

  return (
    <div className="mt-3 mb-3">
      <KC_Heading2
        text={tt("posa_form_preview_reprint_supports")}
        className="mb-2"
      />

      <KC_Text
        text={tt("posa_form_preview_reprint_supports_description")}
        size={KC_Text_Sizes.md}
        weight={KC_Weights.reg}
      />

      <div className="d-flex flex-column flex-md-row flex-wrap st-gap mt-4">
        {props.existingPOSA.map((item) =>
          item.isUpload ? (
            <UploadExistingPOSA
              key={item.format}
              posaOption={item}
              uploadedPOSAList={props.uploadedPOSAList}
              onRefresh={props.onRefresh}
            />
          ) : null
        )}
      </div>

      <Separator />
    </div>
  );
}
